import React, { useState, useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Loader } from "../Common/Loader";
import { PuffLoader, ClipLoader } from "react-spinners";
import ActionButton from "../Common/ActionButton";
import EntrnaceHeader from "./EntranceHeader";
import Popup from "../Common/Popup";

const Enterphone = (props) => {
  const [state, setState] = useState({
    temp: 0,
    loading: false,
    validNumber: false,
    phoneNumber: null,
    statusDisAccount: false,
    verficcationText: "",
  });

  useEffect(() => {
    document.getElementById("entrPhone").classList.add("active");
    checkStatus();
  }, []);

  const checkStatus = () => {
    if (localStorage.getItem("isVerfy")) {
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = function () {
        window.history.go(1);
      };


      base_url
        .get("splash", {

        })
        .then((response) => {
          setTimeout(() => {
            setState({
              ...state,
              verficcationText: response.data.unverified_message,
              statusDisAccount: response.data.is_verify == 0,
            });
          }, 300);
        });
    } else if (localStorage.getItem("logined") !== null) {
      props.history.push(`/`);
    }
  };

  const handlePhoneNumber = (e) => {
    setState({
      ...state,
      phoneNumber: e.target.value,
      validNumber: false,
    });
  };

  const contniue = (e) => {
    e.preventDefault();
    if (/^(\+98|0)?9\d{9}$/.test(state.phoneNumber)) {
      localStorage.setItem("phoneNumber", JSON.stringify(state.phoneNumber));
      setState({
        ...state,
        validNumber: false,
        loading: true,
      });
      const Data = {
        mobile: state.phoneNumber,
      };
     
      base_url
        .post("registerOrLogin", Data)
        .then((response) => {
          document.getElementById("entrPhone").classList.remove("active");
          setTimeout(() => {
            props.history.push("/entrance/step2");
          }, 400);
        });
    } else {
      setState({
        ...state,
        validNumber: true,
      });
    }
  };

  return (
    <Fragment>
      <Popup active={state.statusDisAccount} class="login-popup">
        <i className="icon-bell-fill"></i>
        <span>{state.verficcationText}</span>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={() => window.close()}>
            خروج
          </Button>
        </div>
      </Popup>
      <EntrnaceHeader />
      <div
        id="entrPhone"
        className={`entrnc-web enterphone ${state.loading ? "active" : ""}`}
      >
        <div className="contain">
          <div className="bx-info">
            <div className="titles-style-1">
              <h4>ورود / ثبت نام</h4>
            </div>
            <form onSubmit={(e) => !state.loading && contniue(e)}>
              <div className="info-inputs">
                <div className="input-form">
                  <TextField
                    id="standard-basic"
                    label="شماره موبایل خود را وارد کنید"
                    type="text"
                    onChange={(e) => handlePhoneNumber(e)}
                  />
                  <span
                    className={`error-respns ${
                      state.validNumber ? "active" : ""
                    }`}
                  >
                    <i className="icon-exclamation-mark" />
                    شماره موبایل را بصورت صحیح و کامل وارد کنید
                  </span>
                </div>
              </div>
              <div className="btn-base btn-black btn-sircle">
                <ActionButton
                  WhiteMode={false}
                  OnLoadMode={state.loading}
                  DisableMode={false}
                  ClassNames={["entrance_button", "phoneReceiver"]}
                  DisableOnLoadMode={true}
                  Text={"ادامه"}
                  DoAction={(e) => !state.loading && contniue(e)}
                  // DoAction={() => setState({...state, loading: true})}
                  Type={"submit"}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(Enterphone);
